export interface Occupation {
  id: string;
  name: string;
  chartColor: string;
};

const occupations: Array<Occupation> = [
  {
    id: '1',
    name: 'エンジニア',
    chartColor: 'rgba(255, 99, 132, 0.2)',
  },
  {
    id: '2',
    name: 'プログラマー',
    chartColor: 'rgba(54, 162, 235, 0.2)',
  },
  {
    id: '3',
    name: 'デザイナー',
    chartColor: 'rgba(75, 192, 192, 0.2)',
  },
  {
    id: '4',
    name: 'ディレクター',
    chartColor: 'rgba(149, 111, 225, 0.1)',
  },
];

export default occupations;
